import moment from "moment"
import jsPDF from 'jspdf';
import "jspdf/dist/polyfills.es.js";
import 'jspdf-autotable'
import autoTable from 'jspdf-autotable'

interface Column {
  label: string;
  value: string;
  // Add other properties if needed
}

interface AdvancedFilterResult {
  status: string;
  result: { proband: { id: string }; matching_members: { [key: string]: any }[] }[];
  // Add other properties if needed
}

interface Disease {
  name?: {
    disease_name: string;
    // Add other properties if there are any
  };
  disease_name?: string;
  umls_name?: string;
  age_diagnosed_string: string;
  age_diagnosed?: string;
  // Add other properties if there are any
}


interface Gene {
  name?: {
    gene: string;
  };
  umls_name?: string;
  result: string;
}

type ReferralCriteria = { condition_name?: string } | string;

interface AdvancedFilterResult {
  status: string;
  result: { proband: { id: string }; matching_members: { [key: string]: any }[] }[];
}

const getCliniciansLabel = (clinicians: any)=>{
  let copy_clinicians: any = JSON.parse(JSON.stringify(clinicians));
  let clinicians_label: any[] = []
  for (let clinician of copy_clinicians){
    clinicians_label.push(clinician.label)
  }

  return clinicians_label.join(' ')
}


const getReferralCriteriaString = (proband_referral_criteria_string: string) => {
  let stringforReferralCriteria = ""
  if(proband_referral_criteria_string.includes('Breast/Ovarian')){
    stringforReferralCriteria += "Breast/Ovarian" + " ";
  }
  if(proband_referral_criteria_string.includes('Colorectal')){
    stringforReferralCriteria += "Colorectal" + " ";
  }
  if(proband_referral_criteria_string.includes('Other')){
    stringforReferralCriteria += "Other" + " ";
  }
  if(proband_referral_criteria_string.includes('Gene')){
    stringforReferralCriteria += "Gene" + " ";
  }
  stringforReferralCriteria = stringforReferralCriteria.slice(0, -1)

  return stringforReferralCriteria;
}

 const  getLocaleDateString = () => {
    var formats : { [key: string]: string } = { "ar-SA": "DD/MM/YY", "bg-BG": "DD.MM.YYYY", "ca-ES": "DD/MM/YYYY", "zh-TW": "YYYY/MM/DD", "cs-CZ": "DD.MM.YYYY", "da-DK": "DD-MM-YYYY", "de-DE": "DD.MM.YYYY", "el-GR": "DD/MM/YYYY", "en-US": "MM/DD/YYYY", "fi-FI": "DD.MM.YYYY", "fr-FR": "DD/MM/YYYY", "he-IL": "DD/MM/YYYY", "hu-HU": "YYYY. MM. DD.", "is-IS": "DD.MM.YYYY", "it-IT": "DD/MM/YYYY", "ja-JP": "YYYY/MM/DD", "ko-KR": "YYYY-MM-DD", "nl-NL": "DD-MM-YYYY", "nb-NO": "DD.MM.YYYY", "pl-PL": "YYYY-MM-DD", "pt-BR": "DD/MM/YYYY", "ro-RO": "DD.MM.YYYY", "ru-RU": "DD.MM.YYYY", "hr-HR": "DD.MM.YYYY", "sk-SK": "DD. MM. YYYY", "sq-AL": "YYYY-MM-DD", "sv-SE": "YYYY-MM-DD", "th-TH": "DD/MM/YYYY", "tr-TR": "DD.MM.YYYY", "ur-PK": "DD/MM/YYYY", "id-ID": "DD/MM/YYYY", "uk-UA": "DD.MM.YYYY", "be-BY": "DD.MM.YYYY", "sl-SI": "DD.MM.YYYY", "et-EE": "DD.MM.YYYY", "lv-LV": "YYYY.MM.DD.", "lt-LT": "YYYY.MM.DD", "fa-IR": "MM/DD/YYYY", "vi-VN": "DD/MM/YYYY", "hy-AM": "DD.MM.YYYY", "az-Latn-AZ": "DD.MM.YYYY", "eu-ES": "YYYY/MM/DD", "mk-MK": "DD.MM.YYYY", "af-ZA": "YYYY/MM/DD", "ka-GE": "DD.MM.YYYY", "fo-FO": "DD-MM-YYYY", "hi-IN": "DD-MM-YYYY", "ms-MY": "DD/MM/YYYY", "kk-KZ": "DD.MM.YYYY", "ky-KG": "DD.MM.YY", "sw-KE": "MM/DD/YYYY", "uz-Latn-UZ": "DD/MM YYYY", "tt-RU": "DD.MM.YYYY", "pa-IN": "DD-MM-YY", "gu-IN": "DD-MM-YY", "ta-IN": "DD-MM-YYYY", "te-IN": "DD-MM-YY", "kn-IN": "DD-MM-YY", "mr-IN": "DD-MM-YYYY", "sa-IN": "DD-MM-YYYY", "mn-MN": "YY.MM.DD", "gl-ES": "DD/MM/YY", "kok-IN": "DD-MM-YYYY", "syr-SY": "DD/MM/YYYY", "dv-MV": "DD/MM/YY", "ar-IQ": "DD/MM/YYYY", "zh-CN": "YYYY/MM/DD", "de-CH": "DD.MM.YYYY", "en-GB": "DD/MM/YYYY", "es-MX": "DD/MM/YYYY", "fr-BE": "DD/MM/YYYY", "it-CH": "DD.MM.YYYY", "nl-BE": "DD/MM/YYYY", "nn-NO": "DD.MM.YYYY", "pt-PT": "DD-MM-YYYY", "sr-Latn-CS": "DD.MM.YYYY", "sv-FI": "DD.MM.YYYY", "az-Cyrl-AZ": "DD.MM.YYYY", "ms-BN": "DD/MM/YYYY", "uz-Cyrl-UZ": "DD.MM.YYYY", "ar-EG": "DD/MM/YYYY", "zh-HK": "DD/MM/YYYY", "de-AT": "DD.MM.YYYY", "en-AU": "DD/MM/YYYY", "es-ES": "DD/MM/YYYY", "fr-CA": "YYYY-MM-DD", "sr-Cyrl-CS": "DD.MM.YYYY", "ar-LY": "DD/MM/YYYY", "zh-SG": "DD/MM/YYYY", "de-LU": "DD.MM.YYYY", "en-CA": "DD/MM/YYYY", "es-GT": "DD/MM/YYYY", "fr-CH": "DD.MM.YYYY", "ar-DZ": "DD-MM-YYYY", "zh-MO": "DD/MM/YYYY", "de-LI": "DD.MM.YYYY", "en-NZ": "DD/MM/YYYY", "es-CR": "DD/MM/YYYY", "fr-LU": "DD/MM/YYYY", "ar-MA": "DD-MM-YYYY", "en-IE": "DD/MM/YYYY", "es-PA": "MM/DD/YYYY", "fr-MC": "DD/MM/YYYY", "ar-TN": "DD-MM-YYYY", "en-ZA": "YYYY/MM/DD", "es-DO": "DD/MM/YYYY", "ar-OM": "DD/MM/YYYY", "en-JM": "DD/MM/YYYY", "es-VE": "DD/MM/YYYY", "ar-YE": "DD/MM/YYYY", "en-029": "MM/DD/YYYY", "es-CO": "DD/MM/YYYY", "ar-SY": "DD/MM/YYYY", "en-BZ": "DD/MM/YYYY", "es-PE": "DD/MM/YYYY", "ar-JO": "DD/MM/YYYY", "en-TT": "DD/MM/YYYY", "es-AR": "DD/MM/YYYY", "ar-LB": "DD/MM/YYYY", "en-ZW": "MM/DD/YYYY", "es-EC": "DD/MM/YYYY", "ar-KW": "DD/MM/YYYY", "en-PH": "MM/DD/YYYY", "es-CL": "DD-MM-YYYY", "ar-AE": "DD/MM/YYYY", "es-UY": "DD/MM/YYYY", "ar-BH": "DD/MM/YYYY", "es-PY": "DD/MM/YYYY", "ar-QA": "DD/MM/YYYY", "es-BO": "DD/MM/YYYY", "es-SV": "DD/MM/YYYY", "es-HN": "DD/MM/YYYY", "es-NI": "DD/MM/YYYY", "es-PR": "DD/MM/YYYY", "am-ET": "DD/MM/YYYY", "tzm-Latn-DZ": "DD-MM-YYYY", "iu-Latn-CA": "DD/MM/YYYY", "sma-NO": "DD.MM.YYYY", "mn-Mong-CN": "YYYY/MM/DD", "gd-GB": "DD/MM/YYYY", "en-MY": "DD/MM/YYYY", "prs-AF": "DD/MM/YY", "bn-BD": "DD-MM-YY", "wo-SN": "DD/MM/YYYY", "rw-RW": "MM/DD/YYYY", "qut-GT": "DD/MM/YYYY", "sah-RU": "MM.DD.YYYY", "gsw-FR": "DD/MM/YYYY", "co-FR": "DD/MM/YYYY", "oc-FR": "DD/MM/YYYY", "mi-NZ": "DD/MM/YYYY", "ga-IE": "DD/MM/YYYY", "se-SE": "YYYY-MM-DD", "br-FR": "DD/MM/YYYY", "smn-FI": "DD.MM.YYYY", "moh-CA": "MM/DD/YYYY", "arn-CL": "DD-MM-YYYY", "ii-CN": "YYYY/mM/DD", "dsb-DE": "DD. MM. YYYY", "ig-NG": "DD/MM/YYYY", "kl-GL": "DD-MM-YYYY", "lb-LU": "DD/MM/YYYY", "ba-RU": "DD.MM.YY", "nso-ZA": "YYYY/MM/DD", "quz-BO": "DD/MM/YYYY", "yo-NG": "DD/MM/YYYY", "ha-Latn-NG": "DD/MM/YYYY", "fil-PH": "MM/DD/YYYY", "ps-AF": "DD/MM/YY", "fy-NL": "DD-MM-YYYY", "ne-NP": "MM/DD/YYYY", "se-NO": "DD.MM.YYYY", "iu-Cans-CA": "DD/MM/YYYY", "sr-Latn-RS": "DD.MM.YYYY", "si-LK": "YYYY-MM-DD", "sr-Cyrl-RS": "DD.MM.YYYY", "lo-LA": "DD/MM/YYYY", "km-KH": "YYYY-MM-DD", "cy-GB": "DD/MM/YYYY", "bo-CN": "YYYY/MM/DD", "sms-FI": "DD.MM.YYYY", "as-IN": "DD-MM-YYYY", "ml-IN": "DD-MM-YY", "en-IN": "DD-MM-YYYY", "or-IN": "DD-MM-YY", "bn-IN": "DD-MM-YY", "tk-TM": "DD.MM.YY", "bs-Latn-BA": "DD.MM.YYYY", "mt-MT": "DD/MM/YYYY", "sr-Cyrl-ME": "DD.MM.YYYY", "se-FI": "DD.MM.YYYY", "zu-ZA": "YYYY/MM/DD", "xh-ZA": "YYYY/MM/DD", "tn-ZA": "YYYY/MM/DD", "hsb-DE": "DD. MM. YYYY", "bs-Cyrl-BA": "DD.MM.YYYY", "tg-Cyrl-TJ": "DD.MM.YY", "sr-Latn-BA": "DD.MM.YYYY", "smj-NO": "DD.MM.YYYY", "rm-CH": "DD/MM/YYYY", "smj-SE": "YYYY-MM-DD", "quz-EC": "DD/MM/YYYY", "quz-PE": "DD/MM/YYYY", "hr-BA": "DD.MM.YYYY.", "sr-Latn-ME": "DD.MM.YYYY", "sma-SE": "YYYY-MM-DD", "en-SG": "DD/MM/YYYY", "ug-CN": "YYYY-MM-DD", "sr-Cyrl-BA": "DD.MM.YYYY", "es-US": "MM/DD/YYYY" }
    return formats[navigator.language] || 'DD/MM/YYYY';
  }



export const pdfGenerator = async (columns: any, advanced_filters_results: any, active_advanced_filter: any, probands=[]) =>{

  var doc = new jsPDF({
    orientation: 'landscape',
    unit: 'px'
  });
  let headers: any[] = []
  let rows: any[] = []
  let headersData = columns.forEach((item: { value: string | number; label: string }) => {
    headers.push(item)
  })
  if(active_advanced_filter == 'everyone'){
    const relationship_row = {value: 'relation_to_proband', label: 'Realtionship To Proband'}
    const proband_id = {value: 'proband_id', label: 'Proband ID'}
    headers.push(relationship_row)
    headers.push(proband_id)
  }

  headers = createHeaders(headers)
  function createHeaders(keys: any[]) {
    return keys.map(key => ({
      dataKey: key.value,
      header: key.label,
    }));
  };

  let everyone_results: any[] = [];
  if(advanced_filters_results && (advanced_filters_results.status == 'Completed' || advanced_filters_results.status == 'Running')){
    for(let fam of advanced_filters_results.result){
      const proband_id = fam.proband.id
      const patient_status = fam.family.onboarding_status
      const modified_at = fam.family.last_modified
      if(fam.matching_members){
        fam.matching_members?.forEach((member: { [key: string]: any }) => {
          member['proband_id'] = proband_id;
          member['patient_status'] = patient_status
          member['modified_at'] = modified_at.replace(/\s+/g, '');
        });
        everyone_results = everyone_results.concat(fam.matching_members)
      }else if(fam.proband){
        fam.proband['patient_status'] = patient_status
        fam.proband['modified_at'] = modified_at.replace(/\s+/g, '');
      }
    }
  }

  let results = advanced_filters_results.status == 'Completed' || advanced_filters_results.status == 'Running' ? advanced_filters_results.result : probands

  if (everyone_results.length > 0) results = everyone_results

  //include for referral criteria here
  results.forEach((result: any) => {
    // let clinicians =
    let patient = (advanced_filters_results.status === 'Completed' || advanced_filters_results.status === 'Running') ? (everyone_results.length > 0 ? result : result.proband) : result;
    let referalls = 'referral_condition' in patient ? patient.referral_condition : patient.referral_criteria;
    let clinicians = 'family' in result ? result.family.clinicians : result.clinicians;

    let first_name = "";
    let last_name = "";
    let patient_id = "";
    let birth_date = "";
    let member_disease = "";
    let genes = "";
    let age = "";
    let referall_string = "";
    let status = "";
    let clinician = "";
    let proband_id = "";
    let relationshipProband = "";

    let patient_status = patient.patient_status !== 'no_status' ? patient.patient_status : ''
    let survey_answers: any = patient.survey_answers ? patient.survey_answers : []
      
    let patientSurveyAnswers: any = [];
    survey_answers.forEach((survey: any) => {
      if(survey.answers && typeof survey.answers === 'object'){
        //Add all answers to the allAnswers array
        for(let key of survey.answers){
          //if we are adding the first answer, add it to the array
          if(patientSurveyAnswers.length === 0)patientSurveyAnswers.push(key)
          else{
            let isExist = patientSurveyAnswers.some((obj: any) => obj.question_uuid === key.question_uuid);
            if(!isExist) patientSurveyAnswers.push(key)
          }
        }}else{
        patientSurveyAnswers.push(survey)
      }
    });

    if (patient_status === 'in_progress') patient_status = 'In Progress'
    if (patient.first_name) first_name = patient.first_name;
    if (patient.last_name) last_name = patient.last_name;
    if (patient.patient_id) patient_id = patient.patient_id;
    if (patient.dob) birth_date = patient.dob;
    if (clinicians) clinician = getCliniciansLabel(clinicians);
    if (patient.relation_to_proband) relationshipProband = patient.relation_to_proband;
    if (patient.proband_id) proband_id = patient.proband_id;

    if (patient.diseases) {
      patient.diseases.forEach((disease: Disease) => {
        if (disease.name) member_disease += ` ${disease.name.disease_name.replaceAll(",", " ")} ${disease.age_diagnosed_string} `;
        else if (disease.umls_name) member_disease += ` ${disease.umls_name} ${disease.age_diagnosed_string}`;
        else if (disease.disease_name) member_disease += ` ${disease.disease_name.replaceAll(",", " ")} ${(disease.age_diagnosed) ? disease.age_diagnosed : "?"}`;
      });
    }

    if (patient.gene_summary) {
      patient.gene_summary.forEach((gene: Gene) => {
        if (gene.name) genes += `${gene.name.gene} ${gene.result} `;
        else if (gene.umls_name) genes += `${gene.umls_name} ${gene.result} `;
      });
    }

    if (patient.age > 0) age = patient.age_string ? patient.age_string : patient.age;

    if(referalls){
      let proband_referral_criteria_string = referalls.map((criteria: ReferralCriteria) => {
        let criteria_string = typeof criteria === 'object' && criteria.condition_name !== undefined ? criteria.condition_name : criteria;
         return criteria_string
      });
      let criteria_string = proband_referral_criteria_string.join();
      referall_string = getReferralCriteriaString(criteria_string)
  }


    let row: any = {
      patient_id: patient_id,
      last_name: last_name,
      first_name: first_name,
      sex_at_birth: String(patient.gender).toUpperCase(),
      gender: String(patient.gender).toUpperCase(),
      dob: birth_date,
      modified_at: moment(patient.modified_at).format(getLocaleDateString()),
      age: age,
      diseases: member_disease,
      gene_summary: genes,
      referral_criteria: referall_string,
      patient_status: patient_status,
      clinician: clinician,
      proband_id: proband_id,
      relation_to_proband: relationshipProband
    }      
    if(patientSurveyAnswers.length > 0){
      for(let survey of patientSurveyAnswers){
        let column = survey.master_question ? survey.master_question : survey.question_uuid ? survey.question_uuid : ''
        row[column] = survey.answer ? survey.answer : survey.master_question_choice ? survey.master_question_choice : ''
      }
    }
    rows.push(row)
  });

  const headerFont = headers.length > 7 ? 10 : 12
  const bodyFont = headers.length > 7 ? 9 : 11
  const cellWidth = headers.length > 9 ? 45 : 60


  autoTable(doc, {
    columns: headers,
    body: rows,
    headStyles:{ fontSize: headerFont},
    bodyStyles: { fontSize: bodyFont, valign: 'middle'},
    styles:{valign: 'bottom', minCellWidth: cellWidth}

  })
  doc.save('patient-data.pdf')

  return true

}


export const csvGenertor = async (columns: any, advanced_filters_results: any, active_advanced_filter: any, probands=[]) => {

    let csvHeaderLabels: string[] = [];
    let headers: (string | number)[] = []
    let csvData: any[] = []
    let csvRows: (string | any)[] = []

    columns.forEach((item: { value: string| number; label: string }) => {
      headers.push(item.value)
      csvHeaderLabels.push(item.label)
    })

    if(active_advanced_filter == 'everyone'){
      const relationship_row = {value: 'relation_to_proband', label: 'Realtionship To Proband'}
      const proband_id = {value: 'proband_id', label: 'Proband ID'}

      headers.push(proband_id.value)
      csvHeaderLabels.push(proband_id.label)

      headers.push(relationship_row.value)
      csvHeaderLabels.push(relationship_row.label)
    }
    csvRows.push(csvHeaderLabels.join(","))

    let everyone_results: any[] = [];
    if(advanced_filters_results && (advanced_filters_results.status == 'Completed' || advanced_filters_results.status == 'Running')){
      for(let fam of advanced_filters_results.result){
        const proband_id = fam.proband.id
        const patient_status = fam.family.onboarding_status
        const modified_at = fam.family.last_modified
        if(fam.matching_members){
          fam.matching_members?.forEach((member: { [key: string]: any }) => {
            member['proband_id'] = proband_id;
            member['patient_status'] = patient_status
            member['modified_at'] = modified_at.replace(/\s+/g, '');
          });
          everyone_results = everyone_results.concat(fam.matching_members)
        }else if(fam.proband){
          fam.proband['patient_status'] = patient_status
          fam.proband['modified_at'] = modified_at.replace(/\s+/g, '');
        }
      }
    }

    let results = advanced_filters_results.status == 'Completed' || advanced_filters_results.status == 'Running' ? advanced_filters_results.result : probands
    if (everyone_results.length > 0) results = everyone_results

    results.forEach((result: any) => {

      let patient = advanced_filters_results.status == 'Completed' || advanced_filters_results.status == 'Running' ? everyone_results.length > 0 ? result : result.proband : result;
      let referalls = 'referral_condition' in patient ? patient.referral_condition : patient.referral_criteria
      let clinicians = 'family' in result ? result.family.clinicians : result.clinicians;
      let birth_date = ' '
      let member_disease = ''
      let genes = ' '
      let age = null
      let status = ''
      let clinician = ''
      let referall_string = ''
      let proband_id = ''
      let relationshipProband = ''

      let patient_status = patient.patient_status !== 'no_status' ? patient.patient_status : ''
      let survey_answers: any = patient.survey_answers ? patient.survey_answers : []
      
      let patientSurveyAnswers: any = [];
      survey_answers.forEach((survey: any) => {
        if(survey.answers && typeof survey.answers === 'object'){
          //Add all answers to the allAnswers array
          for(let key of survey.answers){
            //if we are adding the first answer, add it to the array
            if(patientSurveyAnswers.length === 0)patientSurveyAnswers.push(key)
            else{
              let isExist = patientSurveyAnswers.some((obj: any) => obj.question_uuid === key.question_uuid);
              if(!isExist) patientSurveyAnswers.push(key)
            }
          }}else{
          patientSurveyAnswers.push(survey)
        }
      });

      if (patient_status === 'in_progress') patient_status = 'In Progress'
      if(clinicians) clinician = getCliniciansLabel(clinicians);
      if(patient.relation_to_proband) relationshipProband = patient.relation_to_proband
      if(patient.proband_id) proband_id = patient.proband_id
      if(patient.dob)birth_date = patient.dob
      if(patient.age) age = patient.age_string ? patient.age_string : patient.age
      if(patient.diseases) {
        patient.diseases.forEach((disease: Disease)=> {
            if(disease.name){
              member_disease += ` ${disease.name.disease_name.replaceAll(",", " ")} ${disease.age_diagnosed_string} `
            }else if(disease.umls_name){
              member_disease += ` ${disease.umls_name} ${disease.age_diagnosed_string}`
            } else if(disease.disease_name){
              member_disease += ` ${disease.disease_name.replaceAll(",", " ")} ${(disease.age_diagnosed) ? disease.age_diagnosed : "?"}`
            }
        })
      }
      if(patient.gene_summary){
        patient.gene_summary.forEach((gene: Gene)=>{
          if(gene.name){
            genes +=  `${gene.name.gene} ${gene.result} `;
          }else if(gene.umls_name){
            genes +=  `${gene.umls_name} ${gene.result} `
          }
        })
      }

      if(referalls){
        let proband_referral_criteria_string = referalls.map((criteria: ReferralCriteria) => {
          let criteria_string = typeof criteria === 'object' && criteria.condition_name !== undefined ? criteria.condition_name : criteria;
           return criteria_string
        });
        let criteria_string = proband_referral_criteria_string.join();
        referall_string = getReferralCriteriaString(criteria_string)
    }
  
      let row: any = {
        patient_id: patient.patient_id,
        last_name: patient.last_name,
        first_name: patient.first_name,
        sex_at_birth: String(patient.gender).toUpperCase(),
        gender: String(patient.gender).toUpperCase(),
        dob: birth_date,
        modified_at: moment(patient.modified_at).format(getLocaleDateString()),
        age: age,
        diseases: member_disease,
        gene_summary: genes,
        proband_id: proband_id,
        patient_status: patient_status,
        relation_to_proband: relationshipProband,
        referral_criteria: referall_string,
        clinician: clinician,
      }
      if(patientSurveyAnswers.length > 0){
        for(let survey of patientSurveyAnswers){
          let column = survey.master_question ? survey.master_question : survey.question_uuid ? survey.question_uuid : ''
          console.log(survey)
          row[column] = survey.answer ? survey.answer : survey.master_question_choice ? survey.master_question_choice : ''
        }
      }
      csvData.push(row)
    });

    console.log(headers)
    for(let row of csvData){
      let values = headers.map(header=>{
        return row[header]
      })
      csvRows.push(values.join(","))
    }


    const csvString: string = csvRows.join("\n")
    var downloadLink = document.createElement("a");
    var blob = new Blob(["\ufeff", csvString]);
    var url = URL.createObjectURL(blob);
    downloadLink.href = url;
    downloadLink.download = "data.csv";

    document.body.appendChild(downloadLink);
    downloadLink.click();
    document.body.removeChild(downloadLink);

    return true

}

export const copyGenerator = async (query_columns: any, advanced_filters_results: any, active_advanced_filter: any[], probands: any[]) => {
  let columns: any = JSON.parse(JSON.stringify(query_columns));
  const table = document.createElement('table');
  table.id = 'hidden-table';
  table.className = 'hidden-table'
  let results = advanced_filters_results.status == 'Completed' || advanced_filters_results.status == 'Running' ? advanced_filters_results.result : probands
  const relationship_row = {value: 'relation_to_proband', label: 'Realtionship To Proband'}
  const proband_row = {value: 'proband_id', label: 'Proband ID'}

  // Create header and header row element
  const thead = document.createElement('thead');
  const headerRow = document.createElement('tr');

  if (Object.keys(advanced_filters_results).length > 0 &&
      (advanced_filters_results.status === 'Completed' ||
        advanced_filters_results.status === 'Running') &&
        advanced_filters_results.result?.[0].hasOwnProperty('matching_members')) {

          columns.push(relationship_row)
          columns.push(proband_row)
  }

  columns.map((item:any) => {
    const emptyHeader = document.createElement('th');
    emptyHeader.textContent = item.label;
    headerRow.appendChild(emptyHeader);
  })

  thead.appendChild(headerRow);
  table.appendChild(thead);

    const tbody = document.createElement('tbody');
   results.forEach((result: any) => {
    const proband_id = result.proband?.id
    if ('matching_members' in result) {
      result.matching_members.forEach((patient: any) => {
        let survey_answers: any = patient.survey_answers ? patient.survey_answers : []
        let patientSurveyAnswers: any = [];
        survey_answers.forEach((survey: any) => {
          if(survey.answers && typeof survey.answers === 'object'){
            //Add all answers to the allAnswers array
            for(let key of survey.answers){
              //if we are adding the first answer, add it to the array
              if(patientSurveyAnswers.length === 0)patientSurveyAnswers.push(key)
              else{
                let isExist = patientSurveyAnswers.some((obj: any) => obj.question_uuid === key.question_uuid);
                if(!isExist) patientSurveyAnswers.push(key)
              }
            }}else{
            patientSurveyAnswers.push(survey)
          }
        });
        const row = document.createElement('tr');
        columns.map((item: any) => {
          const td = document.createElement('td')
          if (item.value === 'dob') {
            td.textContent = moment(patient[item.value]).format(getLocaleDateString());
          }else if (item.value == 'diseases' && patient.diseases) {
            let stringForDisease = " "
            if (patient[item.value] !== undefined && patient[item.value] !== null) {
              for (let disease of patient[item.value]) {
                let age = disease.age_diagnosed_string ? disease.age_diagnosed_string : disease.age_diagnosed ? disease.age_diagnosed : '?'
                let disease_name = advanced_filters_results.status == 'Completed' || advanced_filters_results.status == 'Running' ? disease.disease_name : disease.name ? disease.name.disease_name : null
                if(disease_name){
                  stringForDisease += disease_name + ' ' + age + ', '
                }else if(disease.umls_name){
                  stringForDisease += disease.umls_name + ' ' + age + ', '
                }
              }
              stringForDisease = stringForDisease.slice(0, -2)
              }
              td.textContent =  stringForDisease
            } else if (item.value === 'gene_summary') {
              var stringForGene = "";
              if (patient[item.value] !== undefined && patient[item.value] !== null) {
                for (let gene of patient[item.value]) {

                  if (gene.result === "p") {
                    gene.result = "Pathogenic"
                  }
                  else if (gene.result === "lp") {
                    gene.result = "Likely Pathogenic"
                  }
                  else if (gene.result === "ln") {
                    gene.result = "Likely Benign"
                  }
                  else if (gene.result === "u") {
                    gene.result = "Unsure"
                  }
                  else if (gene.result === "vus") {
                    gene.result = "VUS"
                  }
                  else if (gene.result === "n") {
                    gene.result = "Negative"
                  }else if(gene.result == "No Result"){
                    gene.result = "No Result"
                  }
                  if(gene.name){
                    stringForGene += gene.name.gene + " " + gene.result + ', ';
                  }else if(gene.umls_name){
                    stringForGene += gene.umls_name + " " + gene.result + ', ';
                  }
                }
                stringForGene = stringForGene.slice(0, -2)
              }
              td.textContent = stringForGene
            } else if (item.value === 'referral_criteria'){
              let stringforReferralCriteria = ''
              if((advanced_filters_results.status == 'Completed' || advanced_filters_results.status == 'Running') && patient.referral_criteria){
                let proband_referral_criteria_string = patient.referral_criteria.map((criteria: any) => criteria.condition_name);
                proband_referral_criteria_string = proband_referral_criteria_string.join();
                stringforReferralCriteria = getReferralCriteriaString(proband_referral_criteria_string);
              }
              else{
                stringforReferralCriteria = patient["referral_criteria_string"]
              }
              td.textContent = stringforReferralCriteria
            }else if (item.value === 'last_name' || item.value === 'first_name'){
              td.textContent  = patient[item.value]
            } else if (item.value === 'sex_at_birth'){
              td.textContent  =  patient['gender'] ? patient['gender'].toUpperCase() : ''
            } else if (item.value === 'age'){
              td.textContent  =  patient['age_string'] ? patient['age_string'] : patient[item.value] ? patient[item.value] : ''
            } else if (item.value === 'clinician') {
              let clinicians = advanced_filters_results.status == 'Completed' || advanced_filters_results.status == 'Running' ? result.family.clinicians : patient.clinicians
              let label = getCliniciansLabel(clinicians)
              td.textContent = label
            }else if(item.value === 'proband_id'){
              td.textContent  =  proband_id
            }else if(item.value === 'relation_to_proband'){
              td.textContent  = patient['relation_to_proband']
            } else if(item.value === 'patient_status'){
              td.textContent = result.family?.onboarding_status && result.family?.onboarding_status !=='no_status' ? result.family?.onboarding_status:  patient[item.value]
            }else if(item.value == 'modified_at'){
              let last_mod = result.family?.last_modified ? moment(result.family?.last_modified.replace(/\s+/g, '')).format(getLocaleDateString()):  patient[item.value] ? patient[item.value]  : ''
              td.textContent = last_mod
            }else if(item.isSurveyColumn && patientSurveyAnswers){
              let surveyString = ''
              for(let survey of patientSurveyAnswers){
                if(survey.master_question === item.value || survey.question_uuid === item.value){
                  surveyString += survey.answer ? survey.answer : survey.master_question_choice ? survey.master_question_choice : ''
                }
              }
              td.textContent = surveyString
            }else{
              td.textContent = patient[item.value]
            }
            row.appendChild(td)
            tbody.appendChild(row);
        }
      )
    })
  }else{
      const row = document.createElement('tr');
      let patient = advanced_filters_results.status == 'Completed' || advanced_filters_results.status == 'Running' ? result.proband : result;
      let survey_answers = patient.survey_answers ? patient.survey_answers : []
      let patientSurveyAnswers: any = [];
      survey_answers.forEach((survey: any) => {
        if(survey.answers && typeof survey.answers === 'object'){
          //Add all answers to the allAnswers array
          for(let key of survey.answers){
            //if we are adding the first answer, add it to the array
            if(patientSurveyAnswers.length === 0)patientSurveyAnswers.push(key)
            else{
              let isExist = patientSurveyAnswers.some((obj: any) => obj.question_uuid === key.question_uuid);
              if(!isExist) patientSurveyAnswers.push(key)
            }
          }}else{
          patientSurveyAnswers.push(survey)
        }
      });      columns.map((item: any) => {
        const td = document.createElement('td')
        if (item.value === 'dob') {
          td.textContent = moment(patient[item.value]).format(getLocaleDateString());
        }else if (item.value == 'diseases' && patient.diseases) {
          let stringForDisease = " "
          if (patient[item.value] !== undefined && patient[item.value] !== null) {
            for (let disease of patient[item.value]) {
              let age = disease.age_diagnosed_string ? disease.age_diagnosed_string : disease.age_diagnosed ? disease.age_diagnosed : '?'
              let disease_name = advanced_filters_results.status == 'Completed' || advanced_filters_results.status == 'Running' ? disease.disease_name : disease.name ? disease.name.disease_name : null
              if(disease_name){
                stringForDisease += disease_name + ' ' + age + ', '
              }else if(disease.umls_name){
                stringForDisease += disease.umls_name + ' ' + age + ', '
              }
            }
            stringForDisease = stringForDisease.slice(0, -2)
            }
            td.textContent =  stringForDisease
          } else if (item.value === 'gene_summary') {
            var stringForGene = "";
            if (patient[item.value] !== undefined && patient[item.value] !== null) {
              for (let gene of patient[item.value]) {

                if (gene.result === "p") {
                  gene.result = "Pathogenic"
                }
                else if (gene.result === "lp") {
                  gene.result = "Likely Pathogenic"
                }
                else if (gene.result === "ln") {
                  gene.result = "Likely Benign"
                }
                else if (gene.result === "u") {
                  gene.result = "Unsure"
                }
                else if (gene.result === "vus") {
                  gene.result = "VUS"
                }
                else if (gene.result === "n") {
                  gene.result = "Negative"
                }else if(gene.result == "No Result"){
                  gene.result = "No Result"
                }
                if(gene.name){
                  stringForGene += gene.name.gene + " " + gene.result + ', ';
                }else if(gene.umls_name){
                  stringForGene += gene.umls_name + " " + gene.result + ', ';
                }
              }
              stringForGene = stringForGene.slice(0, -2)
            }
            td.textContent = stringForGene
          } else if (item.value === 'referral_criteria'){
            let stringforReferralCriteria = ''
            if((advanced_filters_results.status == 'Completed' || advanced_filters_results.status == 'Running') && patient.referral_criteria){
              let proband_referral_criteria_string = patient.referral_criteria.map((criteria: any) => criteria.condition_name);
              proband_referral_criteria_string = proband_referral_criteria_string.join();
              stringforReferralCriteria = getReferralCriteriaString(proband_referral_criteria_string);
            }
            else{
              stringforReferralCriteria = patient["referral_criteria_string"]
            }
            td.textContent = stringforReferralCriteria
            //display clinician here
          }else if (item.value === 'last_name' || item.value === 'first_name'){
            td.textContent  = patient[item.value]
          } else if (item.value === 'sex_at_birth'){
            td.textContent  =  patient['gender'] ? patient['gender'].toUpperCase() : ''
          } else if (item.value === 'age'){
            td.textContent  =  patient['age_string'] ? patient['age_string'] : patient[item.value] ? patient[item.value] : ''
          } else if (item.value === 'clinician') {
            let clinicians = advanced_filters_results.status == 'Completed' || advanced_filters_results.status == 'Running' ? result.family.clinicians : patient.clinicians
            let label = getCliniciansLabel(clinicians)
            td.textContent = label
          } else if(item.value === 'patient_status'){
            let status = result.family?.onboarding_status && result.family?.onboarding_status !=='no_status' ? result.family?.onboarding_status:  patient[item.value]
            if(status === 'in_progress') status = 'In Progress'
            td.textContent = result.family?.onboarding_status && result.family?.onboarding_status !=='no_status' ? result.family?.onboarding_status:  patient[item.value]
          } else if(item.value == 'modified_at'){
            let last_mod = result.family?.last_modified ? moment(result.family?.last_modified.replace(/\s+/g, '')).format(getLocaleDateString()): patient[item.value]
            td.textContent = last_mod
          }else if(item.isSurveyColumn && patientSurveyAnswers){
            let surveyString: string = ''
            for(let survey of patientSurveyAnswers){
              if(survey.master_question === item.value || survey.question_uuid === item.value){
                surveyString += survey.answer ? survey.answer : survey.master_question_choice ? survey.master_question_choice : ''
              }
            }
            td.textContent = surveyString
          } else{
            td.textContent = patient[item.value]
          }

        row.appendChild(td)
        tbody.appendChild(row);
    })

  }

  });

    table.appendChild(tbody);

    // Append the table to the document body (off-screen)
    // table.style.position = 'absolute';
    // table.style.left = '-9999px';
    document.body.appendChild(table);

    // Copy the table to the clipboard
    const range = document.createRange();
    range.selectNode(table);
    const selection = window.getSelection();
    if (selection) {
      selection.removeAllRanges();
      selection.addRange(range);
      document.execCommand('copy');
      selection.removeAllRanges();

    }
    let relationshipIndex = columns.findIndex((obj: any) => obj.value === 'relation_to_proband');
    columns.splice(relationshipIndex, 1);
    let probandId = columns.findIndex((obj: any) => obj.valye === 'proband_id');
    columns.splice(probandId, 1);
    // Remove the table from the DOM
    document.body.removeChild(table);

};
